export default __webpack_public_path__ + "static/media/april-min.a1eb3b0e.jpg";